import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { Settings } from "../settings/settings.entity";
import { StyleOrder } from "../style-order/style-order.entity";
import { RackPositionEntity } from "../rm_locations/rack-position.entity";
import { Brands } from "../master-brands/master-brands.entity";
import { Columns } from "../cloumn/column.entity";
import { Departments } from "../departments/departments.entity";
import { Fabrics } from "../fabrics/fabrics-entity";
import { FabricType } from "../fabric-types/fabric-type.entity";
import { Levels } from "../level/level.entity";
import { FabricWeave } from "../fabric weave/fabric-weave.entity";
import { ProfitControlHead } from "../profit-control-head/profit-control-head-entity";
import { Size } from "../sizes/sizes-entity";
import { RacksEntity } from "../racks/rack.entity";
import Operation from "antd/es/transfer/operation";
import { Operations } from "../operations/operation.entity";
import { TrimParamsMapping } from "../trim-params-mapping/trim-params-mapping.entity";
import { PatternEntity } from "../pattern/pattern.entity";
import { trimEntity } from "../Trim Masters/trim/trim-entity";
import { ContentEntity } from "../Trim Masters/content-master/dto/content-entity";
import { Product } from "../product-master/product.entity";
import { ArticleEntity } from "../Trim Masters/article/article.entity";
import { PurchaseOrderType } from "../purchase-order-type/purchase-order-type-entity";
import { AddressEntity } from "../address/address-entity";
import { M3TrimsEntity } from "../m3-trims/m3-trims.entity";
import { M3ItemsEntity } from "../m3-items/m3-items.entity";
import { Colour } from "../colours/colour.entity";
import { Style } from "../style/dto/style-entity";
import { FactoriesEntity } from "../factories/factories.entity";

@Entity('plants')
export class Plants {

  @PrimaryGeneratedColumn("increment",{name:'plant_id'})
  plantId:number;

  @Column('varchar',{
    name:'plant_Name',
    length:250,
    nullable: false
  })
  plantName: string;

  @Column('varchar',{
    name:'plant_code',
    length:250,
  })
  plantCode: string;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
  })
  isActive:boolean;

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      name: "created_user",
      default: "ADMIN",
      length:50
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user",
      length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;

@OneToMany(type=>Brands,plants=>plants.plant,{cascade:true})
brandinfo:Brands

// @OneToMany(type=>Columns,plants=>plants.plantInfo,{cascade:true})
// columnInfo:Columns

@OneToMany(type=>Departments,plants=>plants.plantInfo,{cascade:true})
departmentInfo:Departments

@OneToMany(type=>Departments,plants=>plants.plantInfo,{cascade:true})
fabricFinishInfo:Departments

@OneToMany(type=>FabricType,plants=>plants.plantInfo,{cascade:true})
fabrictypeInfo:FabricType

// @OneToMany(type=>Levels,plants=>plants.plantInfo,{cascade:true})
// levelInfo:Levels

@OneToMany(type=>FabricWeave,plants=>plants.plantInfo,{cascade:true})
fabricweaveInfo:FabricWeave

@OneToMany(type=>ProfitControlHead,plants=>plants.plantInfo,{cascade:true})
pchInfo:ProfitControlHead

@OneToMany(type=>Size,plants=>plants.plantInfo,{cascade:true})
sizeInfo:Size

@OneToMany(type=>RacksEntity,plants=>plants.plantInfo,{cascade:true})
rackInfo:RacksEntity

@OneToMany(type=>RackPositionEntity,plants=>plants.plantInfo,{cascade:true})
rackpositionInfo:RackPositionEntity

@OneToMany(type=>Operations,plants=>plants.plantInfo,{cascade:true})
operationInfo:Operations

@OneToMany(type=>TrimParamsMapping,plants=>plants.plantInfo,{cascade:true})
trimparamsInfo:TrimParamsMapping[]


@OneToMany(type=>PatternEntity,plants=>plants.plantInfo,{cascade:true})
patternInfo:PatternEntity

@OneToMany(type=>trimEntity,plants=>plants.plantInfo,{cascade:true})
trimInfo:trimEntity

@OneToMany(type=>ContentEntity,plants=>plants.plantInfo,{cascade:true})
contentInfo:ContentEntity

@OneToMany(type=>Product,plants=>plants.plantInfo,{cascade:true})
productInfo:Product

@OneToMany(type=>ArticleEntity,plants=>plants.plantInfo,{cascade:true})
articleInfo:ArticleEntity

@OneToMany(type=>PurchaseOrderType,plants=>plants.plantInfo,{cascade:true})
purchaseorderInfo:PurchaseOrderType

@OneToMany(type=>AddressEntity,plants=>plants.plantInfo,{cascade:true})
invoiceaddInfo:AddressEntity

@OneToMany(type=>M3TrimsEntity,plants=>plants.plantInfo,{cascade:true})
m3trimsInfo:M3TrimsEntity

// @OneToMany(type=>Colour,plants=>plants.plantInfo,{cascade:true})
// colourInfo:Colour

@OneToMany(type=>Style,plants=>plants.plantInfo,{cascade:true})
styleInfo:Style

@OneToMany(type=>FactoriesEntity,plants=>plants.plantInfo,{cascade:true})
factoryInfo:FactoriesEntity

}